module.exports = __webpack_public_path__ + "img/theme_Management.a0a669fb.svg";